import { apis } from "../constants";
import { request } from "../utils";

export const getGateway = ({ pageNum, pageSize }: { pageSize: number, pageNum: number }) => {
    return request<PagedData<Gateway>>(apis.getGateway, { params: { pageNum, pageSize } })
}

export const deleteGateway = (gatewayId: string) => {
    return request(apis.deleteGateway, { params: { gatewayId }, method: 'delete' })
}

export const updateGateway = (data: Partial<Gateway>) => {
    return request(apis.updateGateway, { data, method: 'put', params: { gatewayId: data.gatewayId } })
}

export const createGateway = (data: Partial<Gateway>) => {
    return request(apis.createGateway, { data, method: 'post' })
}

export type SearchParams = {
    asc: boolean;
    pageNum: number;
    pageSize: number;
    queryMac: string;
    queryName: string;
    sortField: string;
}

export const searchGateway = (data: Partial<SearchParams>) => {
    return request<PagedData<Gateway>>(apis.searchGateway, { method: 'post', data })
}

export const getGatewayDeviceList = (datewayId: string) => {
    return request<{
        "gatewayMac": string,
        "localDevices"?: string[],
        "remoteDevices"?: string[],
    }>(apis.getGatewayDevices, { params: { datewayId } })
}